module.exports = __webpack_public_path__ + "static/media/hero-hoteles.027857b0.webp";